import CircleAlert from '@/common/assets/icons/criceleAlert.svg?react';
import Button from '@/common/components/base/button/Button';
import LoadingButton from '@/common/components/base/button/loadingButton';
import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import MainModal from '@/common/components/base/modal/Modal';
import Typography from '@/common/components/base/typography/Typography';
import { DeactivateActionModalType } from '@/modules/adjusterReportModules/IncidentParticipants/components/modals/deactivitateActionModal/deactivitateActionModal.type';
import useGetOfflineImages from '@/modules/OfflineFiles/hooks/useGetOfflineImages';
import React, { useEffect, useState } from 'react';
import { Box, Flex } from 'styled-system/jsx';

const DeactivateActionModal: React.FC<DeactivateActionModalType> = ({
  closeModal,
  open,
  deactivateAction,
  name,
  loading,
  id,
}) => {
  const handleClose = () => {
    closeModal();
  };
  const { getCurrentFileOfflineImages } = useGetOfflineImages();
  const [text, setText] = useState('');

  const TextGenerator = () => {
    let modalText;
    getCurrentFileOfflineImages({ damagedId: id.toString() }).then(
      (offline) => {
        let hasOffline = offline.hasOffline;
        if (hasOffline) {
          modalText =
            'در صورت غیرفعال کردن زیان دیده، کلیه تصاویر ذخیره شده به صورت آفلاین حذف خواهند شد. آیا مطمئن هستید؟';
        } else {
          modalText = `آیا از غیرفعالسازی زیان‌دیده ${name} اطمینان دارید؟`;
        }
        setText(modalText);
      },
    );
  };
  useEffect(() => {
    if (open) {
      TextGenerator();
    }
  }, [open]);
  return (
    <MainModal open={open} closeModal={closeModal}>
      <Flex direction="column" gap={32}>
        <Box w="100%" display="flex" justifyContent="center">
          <CircleAlert />
        </Box>
        <>
          {text ? (
            <Typography textStyle="b1" color="black-1">
              {text}
            </Typography>
          ) : (
            <Flex justifyContent="center">
              <CircularLoading color="colors.purple-primary" />
            </Flex>
          )}
        </>
        <Flex justifyContent="space-between" gap={8}>
          <Button variant="outlined" fullWidth onClick={handleClose}>
            انصراف
          </Button>
          <LoadingButton
            loading={!!loading}
            onClick={deactivateAction}
            fullWidth
          >
            غیرفعالسازی
          </LoadingButton>
        </Flex>
      </Flex>
    </MainModal>
  );
};
export default DeactivateActionModal;
